import rdc from "./img/rdc.png";
import blog from "./img/blog.png";
import forecast from "./img/forecast.png";
import ctopy from "./img/ctop.png";
import uno from "./img/uno.jpg";
import cow from "./img/im.jpg";
import app from "./img/appp.png";
import covi from "./img/covinews.png";
import tq from "./img/tq.jpg";

const Carddata = [
  {
    imgsrc: rdc,
    title: "لباس خیرہ",
    subtitle:
      "A Web Application using SQL as database. It's a clothes Charity website developed in REACT in which one can donate and receive clothes with proper admin side rendering",
    link: "https://github.com/frazbhattiiii/Clothes-Charity",
  },
  {
    imgsrc: app,
    title: "رعد",
    subtitle:
      "An Index Based Search Engine developed in Python by using the research paper of Google. It's searching and indexing algorithms were implemented using research paper of google",
    link: "https://github.com/frazbhattiiii/IndexBasedSearchEngine",
  },
  {
    imgsrc: tq,
    title: "Data Structures and Algorithms",
    subtitle:
      "Solving many problems using DSA.Implemented in Cpp",
    link: "https://github.com/frazbhattiiii/DSAProjects",
  },
  {
    imgsrc: forecast,
    title: "Hangman Game",
    subtitle:
      "Hangman Game in C using SFML Graphics library with efficient algorithm",
    link: "https://github.com/frazbhattiiii/hangman",
  },
 
  

 
 
];

export default Carddata;
